var _style, _g, _g2, _defs, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125.1 125.1",
    style: {
      enableBackground: "new 0 0 125.1 125.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#47A247;}\n\t.st2{clip-path:url(#SVGID_00000090275380824351378140000000700538777656669335_);fill:#47A247;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000080894159244076714520000007157024273849526419_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 125.1,
    height: 125.1
  }))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.8,48.7H58l-7.7,24h9.4l1-3.6H65l0.9,3.6h10.6L68.8,48.7z M65.8,68H60l-1,3.6h-7.2l7-21.9h9.3l7.1,21.9 h-8.4L65.8,68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.7,64.5h3.4l-1.5-7.7L61.7,64.5z M62.9,63.6l0.6-2.5l0.5,2.5H62.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 33.1,
    y: 32.8,
    width: 60,
    height: 60
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011728768385271087740000001113820598053716151_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    d: "M37.4,57.6 c-0.1,0.4-0.5,0.7-0.8,0.6c-0.4-0.1-0.6-0.5-0.6-0.8c0.1-0.4,0.5-0.7,0.8-0.6C37.2,56.8,37.5,57.2,37.4,57.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    d: "M41.6,49.1l-1-0.1 l-0.8,1.5l0.6,0.8L40,52.1l-2.7-3.5l0.4-0.7l4.4,0.4L41.6,49.1z M38.4,48.8l0.9,1.1l0.5-1L38.4,48.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    points: "43,47  40,44.4 40.5,43.7 43,45.8 44.3,44.3 44.9,44.8  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    d: "M46.4,41.9l-0.5,0.4 l0.8,0.9l-0.7,0.6l-2.6-3.1l1.3-1.1c0.7-0.6,1.6-0.6,2.1,0.1l0,0C47.3,40.4,47.1,41.3,46.4,41.9 M46,40.3 c-0.3-0.3-0.6-0.3-0.9,0l-0.5,0.4l0.8,1l0.5-0.5C46.2,40.9,46.2,40.6,46,40.3L46,40.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    points: "52.1,39.6  51.3,38.1 49.9,38.9 50.7,40.3 49.9,40.8 48,37.2 48.8,36.7 49.5,38.2 51,37.4 50.2,36 51,35.5 52.9,39.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    d: "M57.7,37.6l-0.6-0.8 l-1.7,0.5l-0.1,1l-0.9,0.2L55,34l0.8-0.2l2.8,3.5L57.7,37.6z M55.7,35l-0.2,1.4l1-0.3L55.7,35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    d: "M63.4,36 c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7C64.1,35.7,63.8,36,63.4,36"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    points: "71.2,34.9  70.3,38 69.5,37.8 70.3,34.7 69.1,34.3 69.3,33.5 72.6,34.4 72.4,35.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    points: "75.3,40.1  76,38.6 74.6,37.9 73.8,39.4 73.1,39 74.9,35.3 75.7,35.7 74.9,37.2 76.4,37.9 77.1,36.5 77.9,36.9 76.1,40.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    points: "77.9,41.7  80.5,38.6 82.9,40.5 82.4,41.1 80.7,39.8 80.2,40.4 81.6,41.6 81.1,42.2 79.7,41 79.1,41.7 80.8,43.1 80.3,43.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    points: "86.9,46.5  84.2,48.4 83.7,47.6 86.4,45.8 85.7,44.8 86.4,44.3 88.3,47.1 87.6,47.6  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    d: "M86.3,52.4 c-0.5-1.2,0-2.4,1.1-2.8l0,0c1.1-0.5,2.3,0,2.8,1.2c0.5,1.2,0,2.4-1.1,2.8l0,0C88,54,86.8,53.5,86.3,52.4 M88.7,52.6 c0.6-0.3,1-1,0.7-1.6c-0.3-0.7-1-0.9-1.6-0.6l0,0c-0.6,0.3-1,1-0.7,1.6C87.3,52.7,88.1,52.9,88.7,52.6L88.7,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    d: "M89.2,57.4l-0.1-0.7 L87.9,57l-0.2-0.9l4-0.8L92,57c0.2,1-0.3,1.6-1.1,1.8l0,0C90,59,89.4,58.3,89.2,57.4 M90.7,57.9c0.4-0.1,0.5-0.4,0.5-0.8 l-0.1-0.7l-1.2,0.2l0.1,0.7C90.1,57.7,90.4,58,90.7,57.9L90.7,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    d: "M88.2,65.5 c0.1-1.3,1.2-2,2.3-1.9l0,0c1.1,0.1,2,1.2,1.8,2.4c-0.2,1.3-1.2,2-2.3,1.9l0,0C88.9,67.8,88.1,66.7,88.2,65.5 M90.1,67 c0.7,0.1,1.3-0.4,1.4-1.1c0.1-0.7-0.4-1.3-1.1-1.4l0,0c-0.7-0.1-1.3,0.4-1.4,1.1C88.9,66.3,89.4,66.9,90.1,67L90.1,67z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    points: "90.4,71.1  89.5,70.9 88.9,72.7 88.2,72.5 88.8,70.6 87.3,70.1 87.6,69.3 91.4,70.6 90.4,73.5 89.7,73.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    points: "86.4,79.1  83.8,77.3 84.3,76.5 86.9,78.4 87.6,77.4 88.3,77.8 86.4,80.6 85.7,80.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    points: "80.1,81.4  81.3,82.6 82.5,81.4 81.3,80.2 82,79.6 84.8,82.6 84.1,83.2 83,82 81.8,83.2 83,84.3 82.3,84.9 79.5,82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    points: "77.7,83.3  79.9,86.8 77.3,88.4 76.9,87.8 78.7,86.6 78.3,85.9 76.7,86.9 76.2,86.2 77.9,85.2 77.4,84.5 75.5,85.7 75.1,85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    points: "71.1,90.1  70.9,89.2 69.1,89.8 68.8,89 70.7,88.5 70.3,86.9 71.2,86.7 72.2,90.6 69.2,91.5 69,90.7  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    d: "M64.9,87.8 c1.2-0.1,2.2,0.8,2.3,2l0,0c0.1,1.2-0.8,2.2-2,2.3c-1.2,0.1-2.2-0.8-2.3-2l0,0C62.8,88.9,63.6,87.9,64.9,87.8 M63.8,90 c0,0.7,0.6,1.2,1.3,1.2c0.7,0,1.2-0.7,1.1-1.4l0,0c0-0.7-0.6-1.2-1.3-1.2C64.2,88.7,63.8,89.3,63.8,90L63.8,90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    d: "M59.2,87.6 c1.2,0.2,2,1.3,1.8,2.4l0,0c-0.2,1.1-1.2,1.9-2.5,1.7c-1.2-0.2-2-1.3-1.8-2.4l0,0C56.9,88.2,57.9,87.4,59.2,87.6 M57.6,89.4 c-0.1,0.7,0.3,1.4,1,1.5c0.7,0.1,1.3-0.4,1.4-1.1l0,0c0.1-0.7-0.3-1.4-1-1.5C58.3,88.3,57.7,88.7,57.6,89.4L57.6,89.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    d: "M53.9,86.2l1.5,0.6 l-1.5,3.8L52.4,90c-1.2-0.5-1.7-1.6-1.2-2.7l0,0C51.6,86.2,52.7,85.7,53.9,86.2 M52,87.6c-0.3,0.7,0,1.3,0.7,1.6l0.6,0.3 l0.9-2.3l-0.6-0.3C52.9,86.6,52.3,86.9,52,87.6L52,87.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    d: "M46.9,81.9 c0.9,0.8,1,2.1,0.3,3l0,0c-0.7,0.9-2,1.1-3,0.3c-0.6-0.5-0.8-1-0.8-1.5l0.9-0.1c0.1,0.4,0.2,0.8,0.5,1c0.5,0.4,1.3,0.3,1.7-0.2 l0,0c0.4-0.5,0.4-1.3-0.1-1.7c-0.4-0.3-0.7-0.3-1.1-0.3l-0.1-0.8C45.8,81.3,46.3,81.4,46.9,81.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    points: "42.8,77.6  41.5,78.6 42.6,79.9 43.8,78.9 44.4,79.6 41.2,82.1 40.7,81.4 41.9,80.4 40.9,79.1 39.6,80.1 39.1,79.4 42.3,76.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    d: "M39.9,72.4l-0.7,0.7 l0.7,1.6l1-0.1l0.4,0.8l-4.4,0.2l-0.4-0.7l2.9-3.4L39.9,72.4z M37.7,74.8l1.4-0.1l-0.5-1L37.7,74.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    points: "39,69.9  35.1,71 34.9,70.2 38.8,69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000011728768385271087740000001113820598053716151_)",
      fill: "#47A247"
    },
    points: "38,64.3  35.6,66.6 38.2,66.3 38.3,67.2 34.3,67.6 34.2,66.8 36.4,64.6 33.9,64.9 33.8,64 37.9,63.6  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.484a0dfd12b82c92d5641b6ec237e2a0.svg";
export { ForwardRef as ReactComponent };